import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RequestError} from "../../Entity/RequestError";
import {AppThunk} from "../../../app/store";
import {ProductCatalog} from "../../Entity/Product";
import {getBrandInfoRep, getProductsPromotionsBannerTextsRep, getProductsRep} from "../../Repository/ProductRepository";
import {LocalParams} from "../../../components/LocalParams";
import {Brand} from "../../Entity/Brand";

interface ProductState {
  isRequesting: boolean,
  isRequestSuccess: boolean,
  isRequestFailed: boolean,
  error: RequestError | null,
  products: ProductCatalog|null,
  promoBannerTexts: string[]|null,
  brandInfo: Brand|null,
}

const ProductInitialState: ProductState = {
  isRequesting: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  products: null,
  error: null,
  promoBannerTexts: null,
  brandInfo: null,
}

function getProductsStartRequest(state: ProductState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
  state.products = null;
  state.brandInfo = null;
}

function getProductsFailed(state: ProductState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function getProductsSuccess(state: ProductState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.products = action.payload;
  LocalParams.setItem('productsSelection', JSON.stringify(action.payload));
  LocalParams.setItem('filtersSelected', JSON.stringify(window.location.search));
  state.error = null;
}

function getPromotionBannersSuccess(state: ProductState, action: PayloadAction<string[]>) {
  state.promoBannerTexts = action.payload;
}

function getBrandInfoSuccess(state: ProductState, action: PayloadAction<Brand>) {
  state.brandInfo = action.payload;
}

const productSlice = createSlice({
    name: 'products',
    initialState: ProductInitialState,
    reducers: {
      ProductsStartRequest: getProductsStartRequest,
      ProductsSuccess: getProductsSuccess,
      ProductsFailed: getProductsFailed,
      PromotionBannersSuccess: getPromotionBannersSuccess,
      getBrandInfoSuccessAct: getBrandInfoSuccess,
    }
  }
)

export const {
  ProductsStartRequest,
  ProductsSuccess,
  ProductsFailed,
  PromotionBannersSuccess,
  getBrandInfoSuccessAct
} = productSlice.actions;

export default productSlice.reducer;

export const getProducts = (
  locale: string,
  page: number,
  itemsPerPage: number,
  groupCode: string,
  filterCode: string[] | string,
  filters: any,
  isEndOfStock: boolean
): AppThunk => async dispatch => {
  try {
    // Début de la requête
    dispatch(ProductsStartRequest());

    // Appel à l'API pour récupérer les produits
    const newsApiResponse = await getProductsRep(locale, page, itemsPerPage, groupCode, filterCode, filters, isEndOfStock);

    // Vérification et récupération d'informations sur la marque
    try {
      const brandFilter = filters?.find((filter: any) => filter.index === 'brand');
      if (brandFilter && brandFilter.values?.length === 1) {
        const brandName: string = brandFilter.values[0];

        const brandInfo = await getBrandInfoRep(brandName, locale);
        dispatch(getBrandInfoSuccessAct(brandInfo));
      }
    } catch (err) {
      console.warn('Erreur lors de la récupération des infos de marque :', err);
    }

    // Succès : Envoi des produits au store
    dispatch(ProductsSuccess(newsApiResponse));
  } catch (err) {
    // Conversion de l'erreur en message sérialisable pour Redux
    const errorMessage = err instanceof Error ? err.message : 'Une erreur inconnue est survenue';
    dispatch(ProductsFailed(errorMessage));
  }
};

export const getProductsPromotionsBannerTexts = (): AppThunk => async dispatch => {
  try {
    const newsApiResponse = await getProductsPromotionsBannerTextsRep();
    dispatch(PromotionBannersSuccess(newsApiResponse));
  } catch (err) {
  }
}
